import React from 'react'

import { Form, Select, Input } from 'formik-antd'
import { Divider } from 'antd'
import { InputDateTime } from '../../../../core/components/form'

import { getDefaultTimezone } from '../../../../core/utils/timezones'
import { DATETIME_FORMAT } from '../../../../core/utils/i18n-js'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 }
}

const Formulario = ({ projects, pointOfSalesByProject, componentsByPointOfSale, managers, formik }) => {
  const { values, setFieldValue, errors, touched } = formik
  return (
    <>
      <Form.Item label='E-ID' name='eid' hasFeedback showValidateSuccess required>
        <Input name='eid' placeholder='LP / LR / External ID' />
      </Form.Item>

      <Form.Item label='Name' name='name' hasFeedback showValidateSuccess required>
        <Input name='name' placeholder='Name' />
      </Form.Item>

      <Form.Item
          label='Project'
          name='project'
          hasFeedback
          showValidateSuccess
          required
      >
        <Select
          placeholder='Project'
          name='project'
          showSearch
          options={projects}
          filterOption={_filter}
          onChange={(e) => {
            setFieldValue('point_of_sale', null)
            setFieldValue('component', null)
            setFieldValue('project', e)
          }}
        />
      </Form.Item>

      <Form.Item
        label='Point Of Sale'
        name='point_of_sale'
        hasFeedback
        showValidateSuccess
      >
        <Select
          placeholder='Point Of Sale'
          name='point_of_sale'
          showSearch
          options={pointOfSalesByProject(values.project)}
          filterOption={_filter}
        />
      </Form.Item>

      <Form.Item label='Component' name='component'>
        <Select
          placeholder='Component'
          name='component'
          showSearch
          options={componentsByPointOfSale(values.point_of_sale)}
          filterOption={_filter}
        />
      </Form.Item>

      <Form.Item label='Receivable Code' name='code' hasFeedback showValidateSuccess>
        <Input name='code' placeholder='Receivable Code' />
      </Form.Item>

      <Form.Item
        label='Manager'
        name='manager'
        hasFeedback
        showValidateSuccess
        required
      >
        <Select
          placeholder='Manager'
          name='manager'
          showSearch
          options={managers}
          filterOption={_filter}
        />
      </Form.Item>

      <InputDateTime
        name='received_at'
        label='Received At'
        placeholder='Received At'
        errors={errors.received_at}
        touched={touched.received_at}
        layout='horizontal'
        formItemLayout={formItemLayout}
        showTime={{ format: 'HH:mm', minuteStep: 15 }}
        format={DATETIME_FORMAT}
        defaultTimezone={values.received_at ? values.received_at.tz() : getDefaultTimezone()}
      />

      <InputDateTime
        name='client_deadline_at'
        label='Client Deadline At'
        placeholder='Client Deadline At'
        errors={errors.client_deadline_at}
        touched={touched.client_deadline_at}
        layout='horizontal'
        formItemLayout={formItemLayout}
        showTime={{ format: 'HH:mm', minuteStep: 15 }}
        format={DATETIME_FORMAT}
        defaultTimezone={
            values.client_deadline_at ? values.client_deadline_at.tz() : getDefaultTimezone()
        }
      />

      <Form.Item label='Notes' name='notes'>
        <Input.TextArea name='notes' placeholder='Notes' />
      </Form.Item>

      <Divider plain />
    </>
  )
}

export default Formulario